import { SearchOutlined } from '@ant-design/icons'
import { Progress, theme as antdTheme } from 'antd'
import { resolveToneColor } from 'features/libra/dashboard/ticketDashboard/pillTone'
import type { TicketView } from 'features/libra/dashboard/ticketDashboard/types'
import type { FC } from 'react'
import { memo } from 'react'

const RING_SIZE = 32

interface TicketProgressProps {
  progress: NonNullable<TicketView['progress']>
}

const renderReviewIcon = () => <SearchOutlined />

/**
 * antd turns 100% into a green success check. A ticket still in review shows a
 * magnifying glass instead, so it doesn't read as complete.
 */
const RawTicketProgress: FC<TicketProgressProps> = ({ progress }) => {
  const { token } = antdTheme.useToken()
  return (
    <Progress
      type='circle'
      size={RING_SIZE}
      percent={Math.round(progress.percent)}
      strokeColor={resolveToneColor(progress.tone, token)}
      status={progress.inReview ? 'normal' : undefined}
      format={progress.inReview ? renderReviewIcon : undefined}
    />
  )
}

export const TicketProgress = memo(RawTicketProgress)
